import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { runPreAuth } from './app/preauth/preauth';

if (environment.production) {
  enableProdMode();
}

runPreAuth().then(shouldBootstrap => {
  if (!shouldBootstrap) return; // redirect happened
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
